import AuthContext, { rolesMap } from 'context/authContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import paths from 'routes/paths';
import UserForm from './UserForm';
import { useCreateUser } from 'hooks/useUsers';
import { authHelpers } from 'lib/supabase';

export default function CreateUser() {
  const { organization, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { createUserAsync, isCreating } = useCreateUser();

  const onSubmit = async values => {
    try {
      // If creating a super admin, verify the current user's password first
      if (values.superAdmin && values.adminPassword) {
        const { verified, error } = await authHelpers.verifyPassword(
          user.email,
          values.adminPassword
        );

        if (!verified || error) {
          toast.error('Invalid password. Please enter your correct password.');
          return;
        }
      }

      // Filter out parent-level permissions, keep only child permissions
      const childPermissions = {};
      if (!values.superAdmin && values.permissions) {
        Object.keys(values.permissions).forEach(key => {
          // Check if this is a child permission (has specific actions as properties)
          if (
            values.permissions[key] &&
            typeof values.permissions[key] === 'object' &&
            !key.includes('Parent')
          ) {
            childPermissions[key] = values.permissions[key];
          }
        });
      }

      // Always add dashboard read permission for all users
      childPermissions.dashboard = { read: true };

      // Determine role ID based on selected role
      let roleId = rolesMap.staff.id;
      if (values.superAdmin) {
        roleId = rolesMap.admin.id;
      } else if (values.groundsTeamManager) {
        roleId = rolesMap.groundsTeamManager.id;
      } else if (values.groundTeam) {
        roleId = rolesMap.groundTeam.id;
      }

      await createUserAsync({
        password: values.password,
        email: values.email,
        permissions: values.superAdmin ? null : childPermissions,
        branchId: values.branch,
        firstName: values.firstName,
        lastName: values.lastName,
        organisationId: organization.id,
        roleId
      });

      // Navigate to users list on success
      navigate(paths.userRolesSetting);
    } catch (error) {
      console.error('Create user error:', error);
      // Error toast is handled in the hook
    }
  };

  return <UserForm loading={isCreating} onSubmit={onSubmit} />;
}
